import alt from 'components/Dispatcher';

class ManagerDashboardActions {
  constructor() {
    this.generateActions(
      'getWidget',
      'getWidgetError',
      'getWidgetSuccess',
      'getScoredCallIdsError',
      'getScoredCallIdsSuccess',
      'saveDashboardSearch',
      'resetSearch',
      'setShouldResetSearch',
      'setWidgetState',
      'getWidgetState',
      'hasRenderedDashv2Gif',
      'reset'
    );
  }
}

export default alt.createActions(ManagerDashboardActions);
